import React from 'react';
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

// Components
import { Text } from '@beef/ui-kit';
import { ChildNumber } from './components/ChildNumber';
import { CtnStatus } from './components/CtnStatus';

// Constants
import { INVITATION_STATUS } from '../../constants';

// Utils
import { maskPhoneNumber } from '../../../../utils/validators';
import { sharingDescription } from '../../utils';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const FamilyMembersList = () => {
  const {
    isSeb,
    invites,
    count,
    content: { sebInviteDescription, sdbInviteDescription },
  } = useSelector((state) => state.family);
  const history = useHistory();

  const handleSettingsClick = (ctn) => () => {
    history.push(`/limited-family/${ctn}`);
  };

  const inviteDescription = isSeb ? sebInviteDescription : sdbInviteDescription;

  const description = sharingDescription(inviteDescription, invites?.length, count);

  return (
    <section>
      <div className={cn('description')}>
        <Text
          color="grey50"
          size="size5-r-s"
        >
          {description}
        </Text>
      </div>
      <div className={cn('list-items')}>
        {invites.map((invite) => {
          const { ctn, status, ...otherProps } = invite;
          return (
            <ChildNumber
              key={ctn}
              ctn={maskPhoneNumber(ctn)}
              onClick={handleSettingsClick(ctn)}
              iconName={status === INVITATION_STATUS.sent ? 'clock' : 'settings'}
              {...otherProps}
            >
              <CtnStatus data={invite} />
            </ChildNumber>
          );
        })}
      </div>

    </section>
  );
};

export { FamilyMembersList };
